import {Component, Input, OnInit} from '@angular/core';
import {AlertController, LoadingController, ModalController} from '@ionic/angular';
import {OperatorModel} from '../../models/operator.model';
import {ActionModel} from '../../models/action.model';
import {FormatDateForAlertsService} from '../../services/format-date-for-alerts.service';
import {NewActionService} from '../../services/new-action.service';
import {ActionPriorityModel} from '../../models/action-priority.model';
import {ActionTypeModel} from '../../models/action-type.model';
import {CallContactService} from '../../services/call-contact.service';
import {SearchcustomerPage} from '../searchcustomer/searchcustomer.page';
import {SearchContactPage} from '../search-contact/search-contact.page';
import {ContactModel} from '../../models/contact.model';
import {CustomerModel} from '../../models/customer.model';
import {InitialsService} from '../../services/initials.service';
import {StateManagerService} from '../../services/state-manager.service';

@Component({
    selector: 'app-action-details',
    templateUrl: './action-details.html',
    styleUrls: ['./action-details.scss'],
})
export class ActionDetails implements OnInit {

    @Input() action: ActionModel;
    @Input() operators: OperatorModel[];
    @Input() actionPriorities: ActionPriorityModel[];
    @Input() actionTypes: ActionTypeModel[];

    actionCopy: ActionModel;
    newCustomer: boolean;
    newContact: boolean;

    constructor(public modalController: ModalController,
                private formatDateForAlert: FormatDateForAlertsService,
                private alertController: AlertController,
                private newActionService: NewActionService,
                public callContact: CallContactService,
                private loadingController: LoadingController,
                private initials: InitialsService,
                private stateManager: StateManagerService) {
    }

    async ngOnInit() {
        this.newCustomer = false;
        this.newContact = false;
        if (!this.action) {
            this.action = this.newActionService.genNewAction();
            await this.newActionService.populateExtraFields(this.action);
            console.log(this.action);
        }
        this.actionCopy = JSON.parse(JSON.stringify(this.action));
        if (!this.actionCopy.customerDTO) {
            this.actionCopy.customerDTO = new CustomerModel();
        }
        if (!this.actionCopy.contactDTO) {
            this.actionCopy.contactDTO = new ContactModel();
        }
    }

    async searchCustomer() {
        const modal = await this.modalController.create({
            component: SearchcustomerPage,
            backdropDismiss: false,
            cssClass: 'modal-fullscreen',
            componentProps: {}
        });

        modal.onDidDismiss().then((dataReturned) => {
            if (dataReturned.data) {
                this.actionCopy.customerDTO = dataReturned.data;
                if (this.actionCopy.contactDTO && this.actionCopy.contactDTO.cust !== this.actionCopy.customerDTO.cod) {
                    this.actionCopy.contactDTO = new ContactModel();
                }
            }
        });
        return await modal.present();
    }

    async searchContact() {
        const modal = await this.modalController.create({
            component: SearchContactPage,
            backdropDismiss: false,
            cssClass: 'modal-fullscreen',
            componentProps: {
                action: this.actionCopy
            }
        });

        modal.onDidDismiss().then((dataReturned) => {
            if (dataReturned.data) {
                this.actionCopy.contactDTO = dataReturned.data;
                this.actionCopy.customerDTO = this.stateManager.getCollection('customer').find(cust => {
                    return cust.cod === this.actionCopy.contactDTO.cust;
                });
            }
        });
        return await modal.present();
    }

    async saveAction() {
        if (this.actionCopy.id === 0) {
            this.persistAction();
        } else {
            const alert = await this.alertController.create({
                message: 'Do you want complete the action?',
                backdropDismiss: false,
                buttons: [
                    {
                        text: 'No',
                        role: 'cancel',
                        cssClass: 'secondary',
                        handler: () => {
                            this.persistAction();
                        }
                    }, {
                        text: 'Yes',
                        handler: () => {
                            this.actionCopy.date_completed = new Date().toISOString();
                            this.persistAction();
                        }
                    }
                ]
            });
            await alert.present();
        }
    }

    async selectDate() {
        const alert = await this.alertController.create({
            header: 'Select Date',
            backdropDismiss: false,
            inputs: [
                {
                    name: 'date',
                    type: 'date',
                    value: this.formatDateForAlert.generateDate(new Date().toISOString())
                },
                {
                    name: 'time',
                    type: 'time',
                    value: this.formatDateForAlert.generateTime(new Date().toISOString())
                }
            ],
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => {
                        console.log('Confirm Cancel');
                    }
                }, {
                    text: 'Ok',
                    handler: data => {
                        console.log(data);
                        this.actionCopy.date_scheduled = this.formatDateForAlert.formDate(data.date, data.time);
                    }
                }
            ]
        });
        await alert.present();
    }

    async persistAction() {
        if (this.newCustomer && !this.actionCopy.customerDTO.name) {
            alert('Please inform the Customer Name');
            return;
        }
        if (this.newContact && !this.actionCopy.contactDTO.name && !this.actionCopy.contactDTO.id) {
            alert('Please inform the Contact Name');
            return;
        }
        this.action = JSON.parse(JSON.stringify(this.actionCopy));
        this.action.cust_id = this.action.customerDTO.id;
        this.action.actee_map_id = this.action.contactDTO.id;
        console.log('action saved!', this.action);

        if (this.action.id > 0) {
            let queuedActions = this.stateManager.getCollection('queuedaction'); // .findAndRemove({id: this.action.id});
            queuedActions = queuedActions.filter(action => {
                return action.id !== this.action.id;
            });
            this.stateManager.getCache('queuedaction', queuedActions);
            delete this.action.$loki;
            delete this.action.meta;
        }
        this.stateManager.upsert('action', '$loki', this.action);
        this.stateManager.saveDatabase();
        await this.modalController.dismiss(this.action);
    }

    clearCustomer() {
        this.actionCopy.customerDTO = new CustomerModel();
        this.actionCopy.contactDTO = new ContactModel();
    }

    updateContactName(event: any) {
        console.log(event);
        this.actionCopy.contactDTO.name = event.detail.value;
    }

    addTimestamp() {
        let comment = '--- ' + this.formatDate(new Date()) + ' ' + this.initials.formatInitials(this.actionCopy.actorName) + '---';
        if (this.actionCopy.comment && this.actionCopy.comment.length > 0) {
            comment = '\n' + comment;
        }
        this.actionCopy.comment += comment;
    }

    formatDate(date: Date) {
        const monthNames = [
            'January', 'February', 'March',
            'April', 'May', 'June', 'July',
            'August', 'September', 'October',
            'November', 'December'
        ];
        const day = date.getDate();
        const monthIndex = date.getMonth();
        const year = date.getFullYear();
        const hour = date.getHours();
        const minutes = date.getMinutes();

        return day + ' ' + monthNames[monthIndex] + ' ' + year + ' ' + hour + ':' + minutes;
    }

    processNewCustomerNewContact() {
        if (this.newCustomer) {
            this.actionCopy.customerDTO = new CustomerModel();
            this.actionCopy.customerDTO.id = 0;
        }
        if (this.newContact) {
            this.actionCopy.contactDTO = new ContactModel();
            this.actionCopy.contactDTO.id = 0;
        }
    }
}
